import React from 'react';
import TypeFilterItem from './TypeFilterItem';
import { Button } from 'antd';

export default function TypeFilterList({ typesArray, selectedTypesArray, updateFilter, clearFilter, isFilter }) {

  if (Array.isArray(typesArray) && Array.isArray(selectedTypesArray) && isFilter) {
    return (
      <ul className="filter-list filter-list-type mb-2">
        {typesArray.map((type) => <TypeFilterItem key={type.id}
                                                  type={type}
                                                  updateFilter={updateFilter}
                                                  clearFilter={clearFilter}
                                                  isSelected={selectedTypesArray.includes(type.id)}
        />)}
        <Button onClick={clearFilter()}>Clear All</Button>
      </ul>
    );
  }

  return null;
}



// WEBPACK FOOTER //
// ./src/containers/Types/components/TypeFilterList/index.js